type NutritionalInfo = {
  name: string;
  calories: number;
  quantity: number;
};

type NutritionalInfoOption = {
  name: string;
  nutritionalInformation: OptionNutritionalInformation[];
};

type OptionNutritionalInformation = {
  name: string;
  calories: number;
  default: boolean;
};

export type { NutritionalInfo, NutritionalInfoOption };
